import styled from "styled-components";

export const InlineEditWrapper = styled.div`
  .inline-edit-modal-box {
    display: flex;
    flex-direction: column;
  }

  .inline-edit-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 24px;
  }

  .inline-edit-close-icon {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
  }
`;
